var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.002,
    viewBox: "0 0 20 20.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Text_Body_2_Selected_On_Surface_Medium_Emphasis_Left_",
    "data-name": "\\u2731 / Text / Body 2 / Selected / On Surface / Medium Emphasis / Left ",
    d: "M9.543-.168,4.867-4.844A8.122,8.122,0,0,0,6.174-10.5,8.17,8.17,0,0,0-.812-17.433a8.132,8.132,0,0,0-9.12,9.12A8.168,8.168,0,0,0-3-1.324,8.121,8.121,0,0,0,2.657-2.631L7.333,2.045A1.564,1.564,0,0,0,9.543-.168ZM-6.91-9.375a5.006,5.006,0,0,1,5-5,5.006,5.006,0,0,1,5,5,5.006,5.006,0,0,1-5,5A5.005,5.005,0,0,1-6.91-9.375Z",
    transform: "translate(10 17.5)",
    fill: "#707070"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.74bb59f4710a907bd24377482518bc02.svg";
export { ForwardRef as ReactComponent };